module.exports = __webpack_public_path__ + "img/zhaobiao.4aca61cf.png";